import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Button, IconName } from '@optimus-web/core';

interface ProductItemsButtonProps {
    productsCount: number;
    onClick: () => void;
}

export const ProductItemsButton = ({ productsCount, onClick }: ProductItemsButtonProps) => {
    if (productsCount === 0) return null;

    return (
        <Button icon={IconName.ViewReport} variant="ghost" onClick={onClick} type="submit">
            <LocalizedText textKey={TextKey.GeneralItemsCount} substitutes={{ count: productsCount }} />
        </Button>
    );
};
